import React from 'react'
import { connect } from 'react-redux'
import styles from './section.module.scss'
import BackgroundImage from './BackgroundImage'
import Item from './Item'

class SectionContainer extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      itemWidthRatio: 1,
      itemHeightRatio: 1,
      elementsToLoad: props.primary.background_image
        ? 1 + props.items.length
        : props.items.length,
      elementsLoaded: 0,
    }
    this.toggleContent = this.toggleContent.bind(this)
    this.onWindowResize = this.onWindowResize.bind(this)
    this.onElementLoad = this.onElementLoad.bind(this)
    this.wrapperRef = React.createRef()
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onWindowResize)
      this.setState({
        elementsToLoad: 0,
        elementsLoaded: 0,
      })
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onWindowResize)
      this.onWindowResize()
    }
  }

  toggleContent() {
    this.setState(prevState => ({
      contentToggled: !prevState.contentToggled,
    }))
  }

  onWindowResize() {
    const width = this.props.primary.background_image.dimensions.width
    const wWidth = window.innerWidth
    const widthRatio = (wWidth / width).toFixed(2)
    const height = this.props.primary.background_image.dimensions.height
    const wHeight = window.innerHeight
    const heightRatio = (wHeight / height).toFixed
    this.setState({
      itemWidthRatio: widthRatio,
      itemHeightRatio: heightRatio,
    })
  }

  onElementLoad() {
    this.setState(prevState => ({
      elementsLoaded: prevState.elementsLoaded + 1,
    }))
  }

  render() {
    const { title } = this.props
    const {
      background_image,
      color_opacity,
      color_overlay,
      layer,
    } = this.props.primary
    const contentCssClass = [styles.c, styles.showContent]
    let zIndex = layer
    if (!zIndex) {
      zIndex = 50
    }
    return (
      <section
        className={styles.s}
        style={{ zIndex: zIndex }}
        ref={this.wrapperRef}
      >
        <div>
          <BackgroundImage
            img={background_image}
            onElementLoad={this.onElementLoad}
          />
          <div className={contentCssClass.join(' ')}>
            {title && (
              <header className={styles.h}>
                <h1 className={styles.t}>{title[0].text}</h1>
              </header>
            )}
            {this.props.items.map((x, i) => {
              return (
                <Item
                  key={`item_${i}`}
                  wrapper={this.wrapperRef.current}
                  widthRatio={this.state.itemWidthRatio}
                  heightRatio={this.state.itemHeightRatio}
                  onElementLoad={this.onElementLoad}
                  {...x}
                />
              )
            })}
          </div>
          {color_overlay !== null && (
            <div
              className={styles.o}
              style={{
                backgroundColor: color_overlay,
                opacity: color_opacity !== null ? color_opacity : 1,
              }}
            />
          )}
        </div>
      </section>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.elementsLoaded === this.state.elementsToLoad) {
      this.props.onSectionLoad()
    }
  }
}

const mapStateToProps = state => {
  return {
    loading: state.loader.loading,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const Section = connect(mapStateToProps, mapDispatchToProps)(SectionContainer)

Section.defaultProps = {}

Section.propTypes = {}

export default Section

export const sectionQuery = graphql`
  fragment Sections on CaseJson {
    data {
      body {
        primary {
          id
          background_image {
            dimensions {
              width
              height
            }
            url
            tall {
              dimensions {
                width
                height
              }
              url
            }
            medium {
              dimensions {
                width
                height
              }
              url
            }
          }
          color_overlay
          color_opacity
          layer
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Section/index.jsx